export const selectThemeMode = (state) => state.theme.mode;
export const selectThemeColor = (state) => state.theme.color;

export const selectDaisyTheme = (state) => state.theme.daisy;
